var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 13.8361V13.4092C10.0625 12.3531 10.9454 11.4879 12.2026 11.2324L27.6165 7.91068C27.8777 7.85434 28.1515 7.84711 28.4167 7.88954C28.682 7.93198 28.9316 8.02296 29.1463 8.15546C29.361 8.28795 29.5351 8.45843 29.6551 8.65373C29.7752 8.84904 29.8379 9.06396 29.8386 9.28192V10.8474",
    stroke: "#04DB8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8356 19.3821V25.0749C29.8356 26.0647 29.0472 26.8958 27.8933 27.2096L25.951 27.7789C23.6644 28.3994 21.3601 27.0374 21.3601 25.0749C21.3548 24.5707 21.5488 24.0783 21.9138 23.6689C22.2789 23.2595 22.7961 22.9544 23.3907 22.7978L27.8933 21.5062C29.0472 21.1931 29.8356 20.372 29.8356 19.3821ZM29.8356 19.3821V2.4505C29.835 2.34156 29.8033 2.23418 29.7431 2.13665C29.6828 2.03912 29.5956 1.95404 29.4881 1.88797C29.3807 1.8219 29.2558 1.77661 29.1232 1.75557C28.9905 1.73454 28.8537 1.73833 28.7232 1.76666L11.1189 5.58151C10.8119 5.65141 10.5418 5.80071 10.3504 6.00644C10.159 6.21217 10.0567 6.46291 10.0595 6.72006V22.802M10.0595 22.802C10.0595 23.7919 9.27107 24.6237 8.11717 24.9368L3.52628 26.2177C2.30087 26.5507 1.58398 27.443 1.58398 28.4948C1.58398 30.4574 3.92534 31.8072 6.17487 31.1988L8.11717 30.6296C9.27107 30.3165 10.0595 29.4853 10.0595 28.4948V22.802Z",
    stroke: "#04DB8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteImg);
export default __webpack_public_path__ + "static/media/NoteImg.0e4df00fcfbe7db5d9d1958c5bf7aca8.svg";
export { ForwardRef as ReactComponent };